export const COL_1_X_POSITION = 232;
export const COL_2_X_POSITION = 378;
export const COL_3_X_POSITION = 524;

export const ROW_1_Y_POSITION = 134;
export const ROW_2_Y_POSITION = 192;
export const ROW_3_Y_POSITION = 250;
export const ROW_4_Y_POSITION = 309;

export const ISSUE_KEY_TEXT_WIDTH = 90;
